import type { UpdateResolver } from '@urql/exchange-graphcache'
import type {
    AgendaDeletedSubscriptionVariables,
    AgendaUpdatedSubscriptionVariables,
} from '@/generated/gql/graphql'

export const agendasSubscriptionsUpdaters: Record<string, UpdateResolver> = {
    agendaUpdated: (
        _result,
        args: AgendaUpdatedSubscriptionVariables,
        cache,
    ) => {
        cache.invalidate({
            __typename: 'AgendaItemType',
            id: args.agendaId,
        })
    },
    agendaDeleted: (
        _result,
        args: AgendaDeletedSubscriptionVariables,
        cache,
    ) => {
        cache.invalidate({
            __typename: 'AgendaItemType',
            id: args.agendaId,
        })
    },
}
